const ReferenceUserSchemaPlugin = {
  name: 'Reference user schema plugin',
  schema: {
    'user-reference': {
      isVoid: true,
      isInline: true,
    },
  },
};

export default ReferenceUserSchemaPlugin;
